import { Search32 } from '@packages/themes/icons';
import { useDeviceType } from '@packages/shared';
import { Slot } from './Slot';
import { useIsCheckoutRoute } from './useIsCheckoutRoute';
import { DynamicSearchField } from '../SearchField';
import { ArrowBox } from './ArrowBox';
import { useSearchRoute } from '../../utils';

/** Search slot is only displayed on mobile devices and shows the searchfield in the popover */
export const SearchSlot = () => {
  const { isDesktop } = useDeviceType();
  const isCheckoutRoute = useIsCheckoutRoute();
  const searchQuery = useSearchRoute();

  if (isDesktop || isCheckoutRoute) {
    return null;
  }

  // for SERP routes the SearchField is displayed directly in Header.tsx
  return searchQuery ? (
    <Slot icon={<Search32 sx={{ color: 'primary.main' }} />} />
  ) : (
    <Slot icon={<Search32 />}>
      {(left, closePopover) => (
        <ArrowBox left={left + 6}>
          <DynamicSearchField autofocus onSearch={closePopover} />
        </ArrowBox>
      )}
    </Slot>
  );
};
